import { IImageAreaObject } from "../../../../../domain/editableFormat/objects";
import { IImageAreaObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import {
  PrintBehaviorTranslator,
  FreeInputBehaviorTranslator,
  ImageStyleTranslator,
  ScriptExecuteTriggerBehaviorTranslator,
  RelationReplacer,
} from "./properties";
import { ClaioMediaDrawableObjectTranslator } from "./base";

export class ImageAreaObjectTranslator extends AbstractObjectTranslator<IImageAreaObject, IImageAreaObjectBean> {
  constructor() {
    super(new ClaioMediaDrawableObjectTranslator());
  }

  protected shouldRecordName(source: IImageAreaObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IImageAreaObject, bean: IImageAreaObjectBean, formatId: number): void {
    source.printBehavior = this.printBehavior.from(bean);
    source.freeInputBehavior = this.freeInputBehavior.from(bean);
    source.imageStyle = this.imageStyle.from(bean);
    source.scriptExecuteTriggerBehavior = this.scriptExecuteTriggerBehavior.from(bean);
  }

  overwriteBean(source: IImageAreaObjectBean, object: IImageAreaObject): void {
    source["@edit"] = "1";
    source["@hide"] = this.printBehavior.to(object).hide;
    source["@type"] = (object.imageContent.isEnable || object.temporaryImageContent.isEnable) ? "image" : undefined;  // クライオ関連の種別対応が行われる際修正が必要
    source["@free-input-enable"] = this.freeInputBehavior.to(object).freeInputEnable;
    source["@rotate-angle"] = this.imageStyle.to(object).rotateAngle;
    this.relationReplacer.replaceBeans(source, "script-link-output", this.scriptExecuteTriggerBehavior.to(object.scriptExecuteTriggerBehavior));
  }

  private readonly printBehavior = new PrintBehaviorTranslator();
  private readonly freeInputBehavior = new FreeInputBehaviorTranslator();
  private readonly imageStyle = new ImageStyleTranslator();
  private readonly scriptExecuteTriggerBehavior = new ScriptExecuteTriggerBehaviorTranslator();
  private readonly relationReplacer = new RelationReplacer();
}
